import React, { useState } from 'react';
import './PermissionGrid.scss';
import PermissionCategory from './PermissionCategory/PermissionCategory';
import AddRoleModal from './AddRoleModal/AddRoleModal';
import { useStoreContext } from '../../App/StoreProvider';
import * as PermissionRoleEditActions from '../../../store/actions/permissionRoleEdit';
import { isEmpty } from 'lodash';
import { CustomButton } from '../../_common';
import { GET_ROLE_PERMISSIONS } from '../../../graphql/client/queries';
import { GetRolePermissions_getPermissionRoles as getPermissionRoles } from '../../../types/schemaTypes';
import PermissionHeader from './PermissionHeader/PermissionHeader';
import { useMutation } from '@apollo/client/react';
import { CombinedGraphQLErrors } from '@apollo/client';
import { EDIT_PERMISSIONS_ROLE } from '../../../graphql/client/mutations';

import { useAuthContext } from '../../Auth/AuthProvider';
import { PermissionEnum } from '../../../types/PermissionEnum';
interface PermissionGridProps {
    permission: getPermissionRoles;
    refetch: () => Promise<any>;
}

const PermissionGrid = ({ permission, refetch }: PermissionGridProps): React.ReactElement => {
    const [{ permissionRoleEdit }, dispatch] = useStoreContext();
    const [isDisabled, setIsDisabled] = useState(true);
    const { headers, categories } = permissionRoleEdit.currentValues;
    const canEditPermissions = useAuthContext().userHasPermission(PermissionEnum.EditPermissions);
    const [editRole] = useMutation(EDIT_PERMISSIONS_ROLE, {
        onCompleted: () => {
            dispatch(PermissionRoleEditActions.saveAndClearPostedData());
            setIsDisabled(true);
        },
        onError: (e) => {
            if (CombinedGraphQLErrors.is(e)) {
                console.log('GraphQL Error', e.errors);
            } else {
                console.log('Error', e.message);
            }
        },
        refetchQueries: () => {
            return [
                {
                    query: GET_ROLE_PERMISSIONS,
                },
            ];
        },
    });

    const handleDismiss = async (): Promise<void> => {
        dispatch(PermissionRoleEditActions.saveAndClearPostedData());
        setIsDisabled(true);
        const { data } = await refetch();
        dispatch(PermissionRoleEditActions.setInitialData(data.getPermissionRoles));
    };

    React.useEffect(() => {
        
    if (isEmpty(permissionRoleEdit.currentValues) && !isEmpty(permission)) {
        dispatch(PermissionRoleEditActions.setInitialData(permission));
    }

    },[permissionRoleEdit.currentValues, permission]);

    const handleSave = (): void => {
        if (permissionRoleEdit.toBePosted !== null && permissionRoleEdit.toBePosted !== undefined) {
            const variables = {
                input: permissionRoleEdit.toBePosted,
            };
            editRole({ variables });
        }
    };

    const onChange = (roleId: number, permissionId: number, checkedStatus: boolean): void => {
        dispatch(PermissionRoleEditActions.updateGridData(roleId, permissionId, checkedStatus));
        setIsDisabled(false);
    };

    return headers && categories ? (
        <div className="PermissionGrid-GridContainer">
            <div className="PermissionGrid-Header-Buttons">
                <div className="PermissionGrid-Buttons">
                    {canEditPermissions && (
                        <React.Fragment>
                            <CustomButton
                                additionalStyle={'PermissionGrid-AdditionalCancelButton'}
                                isBordered
                                title="Cancel"
                                onClick={handleDismiss}
                            ></CustomButton>
                            <div className="PermissionGrid-Button-Divider"></div>
                            <CustomButton title="Save" onClick={handleSave} isDisabled={isDisabled}></CustomButton>
                        </React.Fragment>
                    )}
                </div>
                <div className="PermisstionGrid-Model">{canEditPermissions && <AddRoleModal />}</div>
            </div>

            <PermissionHeader headers={headers} />

            {categories.map((category, index) => (
                <PermissionCategory key={index} category={category} onChange={onChange} />
            ))}
        </div>
    ) : (
        <div />
    );
};

export default PermissionGrid;
